<mat-form-field class="tw-w-full">
  <mat-label>Time Zone</mat-label>
  <input matInput [required]="required" [(ngModel)]="value" (ngModelChange)="onInputChange($event)"
    [matAutocomplete]="auto" name="timezone" [disabled]="disabled" />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event.option.value)">
    @for(tz of filteredTimezones; track $index) {
    <mat-option [value]="tz.name">
      <div class="tw-flex tw-items-center tw-gap-4 tw-justify-between">
        <span class="text-muted">({{tz.offset}})</span>
        <span>{{tz.name}}</span> 
      </div>
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>